import React, { useState, useEffect } from 'react'

import {
  VStack,
  Container,
  Button,
  Box,
  Text,
  Link,
  HStack,
  PinInput,
  PinInputField,
} from '@chakra-ui/react'

import { Link as RouterLink } from 'react-router-dom'

import { useDispatch, useSelector } from 'react-redux'
import useFeedback from '../../shared/ui/feedback/useFeedbackModal'
import Feedback from '../../shared/ui/feedback/Feedback'

import {
  selectIsLoading,
  selectError,
  selectPasswordReset,
} from '../store/auth.selectors'

import {
  setForgotPasswordVerifyRequest,
  setPasswordResetFailure,
} from '../store/auth.actions'

const OneTimePasswordForm: React.FC = () => {
  const dispatch = useDispatch()
  const [code, setCode] = useState<string>('')
  const isLoading = useSelector(selectIsLoading)
  const errorMessage = useSelector(selectError)
  const { email } = useSelector(selectPasswordReset)

  const { title, setTitle, message, setMessage, isOpen, setIsOpen, returnUrl } =
    useFeedback()

  useEffect(() => {
    if (errorMessage) {
      setTitle('Password Reset Failed')
      setMessage(errorMessage)
      setIsOpen(true)
    } else {
      setTitle('')
      setMessage('')
      setIsOpen(false)
    }
  }, [errorMessage])

  const resetError = () => {
    setTitle('')
    setMessage('')
    setIsOpen(false)
  }

  const submit = () => {
    resetError()
    if (code) {
      dispatch(setForgotPasswordVerifyRequest({ email, code }))
    } else {
      setTitle('Password Reset Failed')
      setMessage('Please enter a valid code.')
      setIsOpen(true)
    }
  }

  const handleClose = () => {
    dispatch(setPasswordResetFailure({ message: '' }))
    resetError()
  }

  return (
    <>
      <Box
        p={5}
        shadow="md"
        borderRadius="md"
        background="#0c0c0c"
        minW="260px"
        w="300px"
      >
        <VStack mb={8} mt={4} spacing={5}>
          <Container>
            <HStack>
              <PinInput
                onComplete={(e) => {
                  resetError()
                  setCode(e)
                }}
              >
                <PinInputField />
                <PinInputField />
                <PinInputField />
                <PinInputField />
                <PinInputField />
                <PinInputField />
              </PinInput>
            </HStack>
          </Container>
          <Container mb={2} centerContent>
            <Text fontSize="sm">
              We&apos;ve sent you an email with a one time code. Please enter
              the code and tap on verify.
            </Text>
          </Container>
        </VStack>
        <VStack>
          <Container mb={1} centerContent>
            <Button
              isLoading={isLoading}
              loadingText="Please wait"
              isFullWidth
              onClick={submit}
              color="white"
              colorScheme="brand"
            >
              Verify
            </Button>
          </Container>
          <Container mb={6} centerContent>
            <Text fontSize="sm">
              Click to{' '}
              <Link
                as={RouterLink}
                fontWeight="bold"
                color="brand.50"
                to="/auth/login/"
              >
                Sign In
              </Link>
            </Text>
          </Container>
        </VStack>
      </Box>
      <Feedback
        title={title}
        message={message}
        isOpen={isOpen}
        returnUrl={returnUrl}
        onClose={handleClose}
      />
    </>
  )
}

export default OneTimePasswordForm
